import translate from "@insite/client-framework/Translate";
import Link, { LinkProps } from "@insite/mobius/Link";
import React from "react";

export interface StoreAnchorProps {
    label: string;
    anchor: string;
}

export interface StoreAnchorLinkProps extends StoreAnchorProps, LinkProps {}

const StoreAnchorLink: React.FC<StoreAnchorLinkProps> = ({ label, anchor, ...otherProps }) => {
    return (
        <Link
            onClick={() => {
                window.location.href = `${window.location.pathname}${window.location.search}#${anchor}`;
            }}
            {...otherProps}
        >
            {/* eslint-disable-next-line spire/avoid-dynamic-translate */}
            {translate(label)}
        </Link>
    );
};

export default StoreAnchorLink;
